import { useQuery, useQueryClient } from '@tanstack/react-query';
import { RQ_SCHEDULED_DEPLOYMENT_SUMMARY } from 'Utils';
import { getScheduledDeploymentSummary } from 'Services';

function useScheduledDeploymentSummary(templateRepositoryId: number | undefined) {
    const queryClient = useQueryClient();
    return useQuery({
        queryKey: [RQ_SCHEDULED_DEPLOYMENT_SUMMARY],
        queryFn: async (): Promise<ScheduledDeploymentSummary> => {
            const previousSummary = queryClient.getQueryData<ScheduledDeploymentSummary>([
                RQ_SCHEDULED_DEPLOYMENT_SUMMARY
            ]);
            const summary = await getScheduledDeploymentSummary(templateRepositoryId!);
            return {
                previous: previousSummary?.current ?? summary,
                current: summary
            };
        },
        enabled: !!templateRepositoryId,
        retry: false
    });
}

export default useScheduledDeploymentSummary;
